/**
 * Convert Katakana to Hiragana
 * @param {string} str - String to convert
 * @returns {string} - Converted string
 */
export function katakanaToHiragana(str) {
  return str.replace(/[\u30A1-\u30F6]/g, (match) => {
    const chr = match.charCodeAt(0) - 0x60;
    return String.fromCharCode(chr);
  });
}

/**
 * Convert Hiragana to Katakana
 * @param {string} str - String to convert
 * @returns {string} - Converted string
 */
export function hiraganaToKatakana(str) {
  return str.replace(/[\u3041-\u3096]/g, (match) => {
    const chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });
}

/**
 * Normalize string for kana matching (converts to hiragana)
 * @param {string} str - String to normalize
 * @returns {string} - Normalized string in hiragana
 */
export function normalizeKana(str) {
  if (!str) return '';
  return katakanaToHiragana(str.toLowerCase());
}

/**
 * Check if search text matches name or kana
 * @param {string} searchText - Search query
 * @param {string} name - Item name
 * @param {string} kana - Item kana
 * @returns {boolean} - True if matches
 */
export function matchesKanaSearch(searchText, name, kana) {
  if (!searchText) return true;
  
  const normalizedSearch = normalizeKana(searchText);
  const normalizedName = normalizeKana(name);
  const normalizedKana = normalizeKana(kana);
  
  // Check if search matches name
  if (normalizedName.includes(normalizedSearch)) {
    return true;
  }
  
  // Check if search matches kana
  if (normalizedKana && normalizedKana.includes(normalizedSearch)) {
    return true;
  }
  
  return false;
}
